import React from 'react';
import './StyleSelector.css';

/**
 * StyleSelector Component
 * Allows users to switch between different UI themes/styles.
 * Displays a "waffle" grid of style preview cards.
 * 
 * @param {string} currentStyle - The ID of the currently active style.
 * @param {function} onStyleSelect - Callback function when a style is selected.
 * @param {Array} styles - Array of style objects { id, name, description, color, previewColor }.
 */
const StyleSelector = ({ currentStyle, onStyleSelect, styles = [] }) => {
    if (!styles || styles.length === 0) return null;

    return (
        <div className="style-selector-container">
            <h3 className="style-selector-title">Select Theme</h3>
            <div className="style-waffle-grid">
                {styles.map((style) => (
                    <div
                        key={style.id}
                        className={`style-card ${currentStyle === style.id ? 'is-active' : ''}`}
                        onClick={() => onStyleSelect(style.id)}
                        style={{ '--preview-color': style.previewColor || style.color }}
                    >
                        <div className="style-preview-box">
                            <div className="style-preview-accent"></div>
                            <div className="style-preview-ui-element"></div>
                        </div>
                        <div className="style-info">
                            <span className="style-name">{style.name}</span>
                            {/* <span className="style-desc">{style.description}</span> */}
                        </div>
                        {currentStyle === style.id && (
                            <div className="style-active-indicator">
                                <i className="fas fa-check"></i>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default StyleSelector;
